// extracted by mini-css-extract-plugin
export var typingIndicator = "_r4-0";